import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMeteorComponent } from './simple-icons-meteor.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMeteorComponent ],
    exports:      [ SimpleIconsMeteorComponent ],
    bootstrap:    []
})
export class SimpleIconsMeteorModule {}
